import { useState, useCallback, useEffect, useRef } from 'react'
import cartDuck from 'components/cart/duck'
import segmentQuickAddToBagClicked from 'components/shared/quick-add-to-bag-modal/quick-add-to-bag-segment/quickAddToBagSegment'

// All add paths now share the same cart/voucher transaction and recovery guard.
export const addDiamondWithVoucher = ({ t, ...options }) =>
  cartDuck.creators.get(options)

const useAddDiamondToCart = ({
  refType,
  addToCart,
  updateCart,
  id_product,
  id_product_attribute,
  applyStoreCredit,
  cartBusy = false,
  t,
}) => {
  const adding = useRef(false)
  const mounted = useRef(true)
  const [isAddingCart, setIsAddingCart] = useState(false)
  useEffect(
    () => () => {
      mounted.current = false
    },
    [],
  )
  const handleClickAddToCart = useCallback(async () => {
    if (adding.current || cartBusy) return
    adding.current = true
    setIsAddingCart(true)
    let result
    try {
      result = await addToCart({
        quantity: 1,
        type: 'AddToCart',
        ignoreCache: true,
        productID: id_product,
        productAttributeID: id_product_attribute,
        body: { is_store_credits_applied: applyStoreCredit },
        t,
      })
      if (
        mounted.current &&
        !result?.stale &&
        result?.ok !== false &&
        result?.items?.some(
          (item) => String(item.id_product) === String(id_product),
        )
      ) {
        segmentQuickAddToBagClicked({ id_product, ref_type: refType })
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    } finally {
      adding.current = false
      if (mounted.current) setIsAddingCart(false)
      if (mounted.current && result && !result.stale) {
        await updateCart({
          cartOpen: true,
          isStoreCreditUsed: applyStoreCredit,
        })
      }
    }
  }, [
    refType,
    addToCart,
    updateCart,
    applyStoreCredit,
    id_product_attribute,
    id_product,
    cartBusy,
    t,
  ])

  return {
    handleClickAddToCart,
    isAddingCart: isAddingCart || cartBusy,
  }
}

export default useAddDiamondToCart
